export const statTypes = {
	totalAgency: 'TotalAgency',
	baseshop: 'Baseshop',
	personal: 'PersonalProduction',
	masterAgency: 'MasterAgency',
}
